export default __webpack_public_path__ + "static/media/zip-icon.c0c7ee24.svg";